import type { RecipeProposal } from './recipeProposal';

/** Entradas sintéticas fijas para demo y dobles de extracción/transcripción. */
export const RECIPE_FIXTURES: Array<{ id: string; text: string; proposals: RecipeProposal[] }> = [
  { id: 'risotto', text: 'Risotto de setas para cuatro: 320 gramos de arroz carnaroli, medio litro de caldo de verduras y 200 gramos de boletus.', proposals: [{
    name: 'Risotto de setas', servings: 4, lines: [
      { rawText: '320 gramos de arroz carnaroli', ingredientName: 'Arroz carnaroli', qty: 320, unit: 'g', estimated: {} },
      { rawText: 'medio litro de caldo de verduras', ingredientName: 'Caldo de verduras', qty: 0.5, unit: 'l', estimated: {} },
      { rawText: '200 gramos de boletus', ingredientName: 'Boletus', qty: 200, unit: 'g', estimated: {} },
    ],
  }] },
  { id: 'dos-platos', text: 'Dos platos: arroz blanco para dos con 200 gramos de arroz. Y tortilla para uno con dos huevos.', proposals: [
    { name: 'Arroz blanco', servings: 2, lines: [{ rawText: '200 gramos de arroz', ingredientName: 'Arroz', qty: 200, unit: 'g', estimated: {} }] },
    { name: 'Tortilla', servings: 1, lines: [{ rawText: 'dos huevos', ingredientName: 'Huevo', qty: 2, unit: 'pz', estimated: {} }] },
  ] },
  { id: 'subreceta', text: 'Pasta para uno: 100 gramos de pasta y 50 gramos del sofrito base que ya tengo hecho.', proposals: [{
    name: 'Pasta con sofrito', servings: 1, lines: [
      { rawText: '100 gramos de pasta', ingredientName: 'Pasta', qty: 100, unit: 'g', estimated: {} },
      { rawText: '50 gramos del sofrito base que ya tengo hecho', ingredientName: 'Sofrito base', qty: 50, unit: 'g', isSubrecipe: true, estimated: {} },
    ],
  }] },
  { id: 'transcripcion-sin-cantidad', text: 'Salteado de voletus, ponle sal al gusto y un poco de aceite, las cantidades no las sé.', proposals: [{
    name: 'Salteado de boletus', lines: [
      { rawText: 'voletus', ingredientName: 'Boletus', estimated: { qty: true } },
      { rawText: 'sal al gusto', ingredientName: 'Sal', estimated: { qty: true } },
      { rawText: 'un poco de aceite', ingredientName: 'Aceite', estimated: { qty: true } },
    ], notes: ['Faltan las cantidades y el tipo de aceite.'],
  }] },
  { id: 'reposteria', text: 'Galletas: 250 gramos de harina, 100 gramos de azúcar y 125 gramos de mantequilla. Salen diez.', proposals: [{
    name: 'Galletas', servings: 10, lines: [
      { rawText: '250 gramos de harina', ingredientName: 'Harina', qty: 250, unit: 'g', estimated: {} },
      { rawText: '100 gramos de azúcar', ingredientName: 'Azúcar', qty: 100, unit: 'g', estimated: {} },
      { rawText: '125 gramos de mantequilla', ingredientName: 'Mantequilla', qty: 125, unit: 'g', estimated: {} },
    ],
  }] },
];
